import { render } from "./Navigation.vue?vue&type=template&id=4d724989&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=4d724989&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cloud-builder-challenge-frontend/cloud-builder-challenge-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d724989"]])

export default __exports__